export default __webpack_public_path__ + "static/affiliatesVp2-ab96943842c8647aaff798c6ce74a8b4.png";